import Head from 'next/head';

//#region [Props]
type PersonSeoProps = {
	name: string;
}
//#endregion

//#region [Component]
export default function PersonSeo({ name }: PersonSeoProps) {
	return <Head>
		<meta key="ogTitle" property="og:title" content={name} />
		<meta key="metaTitle" name="title" content={name} />

		<title key="title">{name} - Filmweb</title>

	</Head>
}
//#endregion